module.exports = __webpack_public_path__ + "img/07-don-pintxos.13dd698f.jpg";